import $ from 'jquery';
import Cookies from 'js-cookie';

class Marketo {
  MUTINY_COOKIE = 'mutiny_crunch';

  constructor($form) {
    let self = this;

    if (!$form.hasClass('old-form')) {
      MktoForms2.loadForm('//go.ontra.ai', '934-BAM-030', $form.data('marketo-form'), function (form) {
        self.form = form;
        self.formatForm();
      });
    }

    MktoForms2.whenReady(function (form) {
      let $form = $(form.getFormElem());

      $form.on('click', '.mktoNotYou', () => {
        Cookies.remove(self.MUTINY_COOKIE);
      });

      // mutiny functionality
      form.onSuccess(function (values, followUpUrl) {
        let userObj = false;
        // Start Mutiny Identify - SDK code block
        let firstName = form.getFormElem().find('input#FirstName').val();
        let lastName = form.getFormElem().find('input#LastName').val();
        let userEmail = form.getFormElem().find('input#Email').val();
        let userCompany = form.getFormElem().find('input#Company').val();

        if ($form.find('.mktoTemplateBox').length === 0) {
          // console.log("new user");
          if (firstName && lastName && userEmail && userCompany) {
            userObj = {
              firstName: firstName,
              lastName: lastName,
              email: userEmail,
              company: userCompany,
            };
            Cookies.set(self.MUTINY_COOKIE, btoa(JSON.stringify(userObj)), { expires: 30 });
          }
        } else {
          // console.log("returning user");
          let userCookie = Cookies.get('mutiny_crunch');
          if (userCookie) {
            userObj = JSON.parse(atob(userCookie));
            // console.log("found user obj: ", userObj);
          }
        }

        if (false !== userObj) {
          if (window.mutiny.client.userDataStore) {
            let userMutinyToken = window.mutiny.client.userDataStore.getUserToken();
            if (userMutinyToken) {
              // console.log("found mutiny token: ", userMutinyToken);
              // console.table(userObj);
              window.mutiny.client.identify(userMutinyToken, userObj);
            }
          } else {
            // console.log("didn't find mutiny token");
            window.mutiny.client.identify(null, userObj);
          }
        }
        // End Mutiny Identify - SDK code block

        // If gated links are showing, make sure they are all the same width, the largest width needed
        if ($('.gated-links').length > 0) {
          setTimeout(() => {
            let maxWidth = 180; // minimum width
            $('.gated-links')
              .find('a')
              .each((index, a) => {
                if ($(a).outerWidth() > maxWidth) {
                  maxWidth = $(a).outerWidth();
                }
              });
            $('.gated-links')
              .find('a')
              .css('width', maxWidth + 'px');
          }, 200);
        }
      });

      $form.find('style').remove();

      $form.trigger('formReady');
      if ($form.data('marketo-form')) {
        form.onSuccess(function (values, followUpUrl) {
          $form.trigger('submitSuccess');
          if ($form.closest('.form-download-wrapper')) {
            $form.closest('.form-download-wrapper').addClass('hide-shadow');
          }
          return false;
        });
      }
      // Only prevent marketo from redirecting for the blog or resource subscribe forms
      if ($form.hasClass('blog-subscribe-form') || $form.hasClass('resources-subscribe-form')) {
        form.onSuccess(function (values, followUpUrl) {
          let $container = $form.closest('.marketo-container');
          $form.remove();
          $container.find('.marketo-thank-you').html($form.data('thank-you')).show();
          return false;
        });
      } else if ($form.hasClass('form-asset')) {
        form.onSuccess(function (values, followUpUrl) {
          // For asset options (webinar/pdf), on success, hide all the content below the hero, and display
          // the webinar(video) or ebook(pdf) below, along with whatever other modules are defined for the page.
          $.ajax({
            url: ontraJs.ajaxUrl,
            method: 'POST',
            data: {
              action: 'asset_form_success',
              pid: $form.data('pid'),
            },
            success: function (data) {
              // Remove all the modules except for the hero
              $('main').children().not(':first').remove();
              // Add the webinar/pdf and other modules
              $('main').append(data);

              // If a post-submit-image has been defined, display it. If the image is an svg animation, use the vivus library
              // to animate it.
              let post_submit_image = $form.data('post-submit-image');
              let formContainer = $form.closest('.form-download-wrapper').parent();
              formContainer.find('.form-download-wrapper').remove();
              if (post_submit_image) {
                let ext = post_submit_image.substr(post_submit_image.lastIndexOf('.') + 1);
                if ('svg' === ext) {
                  let $object = $('<object>').addClass('vivus-svg').attr('type', 'image/svg+xml').data('reverse', 'true').attr('data', post_submit_image);
                  formContainer.append($object);
                  $object.vivusSvg();
                } else {
                  formContainer.append($('<img>').attr('src', post_submit_image));
                }
              }
              $(window).trigger('form-asset-loaded');
            },
          });
        });
      }
    });

    /* This section makes sure all fields including dynamic fields e.g dropdowns that show new fields, get the form-group class.
       .onFormRender() adds a callback that will be called every time any form on the page renders. Forms are rendered when initially created,
       then again every time that visibility rules alter the structure of the form.
       https://developers.marketo.com/javascript-api/forms/api-reference/ */
    MktoForms2.onFormRender(function (form) {
      form
        .getFormElem()
        .find('.mktoFieldWrap')
        .each(function () {
          $(this).addClass('form-group');
        });

      // This rule loads everytime the form renders for first time, and if there are dynamic dropdowns that change the options in the form.
      // Adds class to make form field full width within form container.
      // Removes the width 400px that comes bundled from marketo, so the text expands in form.
      form.getFormElem().find('.mktoHtmlText').removeAttr('style').closest('.mktoFormRow').addClass('is-full');

      // This rule loads everytime the form renders for first time, and if there are dynamic dropdowns that change the options in the form.
      // Removes the width 400px that comes bundled from marketo, so the text expands in form.
      form.getFormElem().find('.mktoCheckboxList').removeAttr('style');

      // In case any select dropdowns change the visibility of other fields,
      // remove the style tags from some fields since we don't want them
      // overriding the width of the fields
      $form.find('.mktoTextField, .mktoTelField').removeAttr('style');

      $(window).on('resize', () => {
        const countryValue = $(this).find('option:selected').text().toLowerCase();
        console.log('country value: ', countryValue);
        if (countryValue === 'united states' || (countryValue === 'canada' && 1886 !== self.form.getId() && 1939 !== self.form.getId())) {
          $form.find('select[name="Preferred_State__c"]').closest('.mktoFormRow').show();
        } else {
          $form.find('.mktoPlaceholderPreferred_State__c').closest('.mktoFormRow').hide();
        }
      });
    });
  }

  formatForm() {
    let self = this;
    let $form = self.form.getFormElem();
    let mktoForm = $form.find('*');
    mktoForm.attr('style', '');
    $form.attr('style', '');
    $(window).on('resize', function () {
      mktoForm.attr('style', '');
      $form.attr('style', '');
    });

    self.form
      .getFormElem()
      .find('.mktoFieldWrap')
      .each(function () {
        $(this).addClass('form-group');
      });

    // Adds class to hide form field within mktoFormRow.
    self.form.getFormElem().find('input[type=hidden]').closest('.mktoFormRow').addClass('is-hidden');

    // Adds class to make form field full width within form container.
    // Removes the width 400px that comes bundled from marketo, so the text expands in form.
    self.form.getFormElem().find('.mktoHtmlText').removeAttr('style').closest('.mktoFormRow').addClass('is-full');

    self.form.getFormElem().find('input[type=range]').closest('.mktoFormRow').addClass('is-slider');

    self.form.getFormElem().find('textarea').closest('.mktoFormRow').addClass('is-textarea is-full');

    // Custom styling full width for conditional Marketo form fields with select/dropdowns.
    self.form.getFormElem().find('select').closest('.mktoFormRow').addClass('is-select is-full');
    //.after('<div class="select-wrapper" />')

    if (1886 !== self.form.getId() && 1939 !== self.form.getId()) {
      self.form.getFormElem().find('.mktoPlaceholderState').closest('.mktoFormRow').addClass('is-select is-full');
    }

    /* Sets the form-group to the State dropdown/select after the Country field (USA or Canada) has been selected.
     *  var countryField = form.getFormElem().find('select[name="Country"]');
     */
    var countryField = self.form.getFormElem().find('select[name="Country"]');
    countryField = $(countryField);

    if (countryField !== undefined) {
      $(countryField).on('change', function () {
        const countryValue = $(this).find('option:selected').text().toLowerCase();
        if (countryValue === 'united states' || countryValue === 'canada') {
          self.form.getFormElem().find('select[name="State"]').closest('.mktoFieldWrap').addClass('form-group');
        }
      });
    }

    /* Sets the form-group to the State dropdown/select after the Country field (USA or Canada) has been selected.
     *  var countryField = form.getFormElem().find('select[name="Preferred_Country__c"]');
     * */
    var preferredCountryField = self.form.getFormElem().find('select[name="Preferred_Country__c"]');
    preferredCountryField = $(preferredCountryField);

    if (preferredCountryField !== undefined) {
      $(preferredCountryField).on('change', function () {
        const countryValue = $(this).find('option:selected').text().toLowerCase();
        if (countryValue === 'united states' || countryValue === 'canada') {
          //Adds this class=form-group, since the dynamic fields in marketo get refreshed everytime a new options is picked up from a select/dropdown.
          self.form.getFormElem().find('select').closest('.mktoFieldWrap').addClass('form-group');
          if (1886 !== self.form.getId() && 1939 !== self.form.getId()) {
            self.form.getFormElem().find('select[name="Preferred_State__c"]').closest('.mktoFormRow').addClass('is-full');
          } else {
            self.form.getFormElem().find('select[name="Preferred_State__c"]').closest('.mktoFormRow').show();
          }
          self.form.getFormElem().find('select[name="Preferred_Gift_Option__c"]').closest('.mktoFormRow').addClass('is-full');
          self.form.getFormElem().find('select[name="Event_Dietary_Restrictions__c"]').closest('.mktoFormRow').addClass('is-full');
        } else {
          self.form.getFormElem().find('.mktoPlaceholderPreferred_State__c').closest('.mktoFormRow').hide();
        }

        /*
         * If there are any special rules for new fields that appear after the Preferred_State field is updated.
         * */
        var preferredStateField = self.form.getFormElem().find('select[name="Preferred_State__c"]');
        preferredStateField = $(preferredStateField);
        if (preferredStateField !== undefined) {
          $(preferredStateField).change(function () {
            //console.log("changed states:");
          });
        }
      });
    }

    /* Code to make some special fields display full-width */

    /* Preferred_Phone_Number__c -- Field showing only outside of USA countries. Holiday Gifting / Direct mail */
    if (1886 !== self.form.getId() && 1939 !== self.form.getId()) {
      self.form.getFormElem().find('input[name="Preferred_Phone_Number__c"]').closest('.mktoFormRow').addClass('is-full');
    } else {
      self.form.getFormElem().find('.mktoPlaceholderPreferred_State__c').closest('.mktoFormRow').hide();
    }

    /* Preferred_Gift_Option__c -- Field showing for Holiday Gifting / Direct mail */
    self.form.getFormElem().find('select[name="Preferred_Gift_Option__c"]').closest('.mktoFieldWrap').addClass('form-group');
    self.form.getFormElem().find('select[name="Preferred_Gift_Option__c"]').closest('.mktoFormRow').addClass('is-full');

    /* Preferred_Country__c -- Field showing for Holiday Gifting / Direct mail */
    self.form.getFormElem().find('select[name="Preferred_Country__c"]').closest('.mktoFormRow').removeClass('is-full');

    /* Preferred_State__c -- Field showing for Holiday Gifting / Direct mail */
    self.form.getFormElem().find('select[name="Preferred_State__c"]').closest('.mktoFormRow').addClass('is-full');

    self.form.getFormElem().find('select[name="Event_Dietary_Restrictions__c"]').closest('.mktoFieldWrap').addClass('form-group');
    self.form.getFormElem().find('select[name="Event_Dietary_Restrictions__c"]').closest('.mktoFormRow').addClass('is-full');

    self.form.getFormElem().find('.mktoPlaceholderEmail_Opt_In__c').closest('.mktoFormRow').addClass('is-full');

    self.form.getFormElem().find('.mktoPlaceholderEU_GDPR_Opt_In__c').closest('.mktoFormRow').addClass('is-full');

    self.form.getFormElem().find('.mktoPlaceholderDouble_Opt_In__c').closest('.mktoFormRow').addClass('is-full');

    // mktoPlaceholderEU_GDPR_Opt_In__c
    // mktoPlaceholderDouble_Opt_In__c
    // mktoPlaceholderEmail_Opt_In__c
    // mktoPlaceholderState

    //form.getFormElem().find('select').after('<div class="select-wrapper" />').closest('.mktoFormRow').addClass('is-select');

    // Add select2 to all select elements
    // form.getFormElem().find('select').each(function(i, el) {
    //     $(el).select2({
    //         minimumResultsForSearch: Infinity,
    //         dropdownAutoWidth: true,
    //         width: 'auto',
    //         dropdownParent: $(el).next('.select-wrapper')
    //     });
    // });

    // Checkbox, wrap each input+label and add markup
    self.form
      .getFormElem()
      .find('input[type=checkbox]')
      .each(function (i, el) {
        var id = $(el).attr('id');

        $('input#' + id + ', label[for=' + id + ']:not(.mktoLabel)')
          .wrapAll('<div />')
          .closest('.mktoFormRow')
          .addClass('is-checkbox');

        // Single checkbox
        if ($('label[for=' + id + ']:not(.mktoLabel)').is(':empty')) {
          $(this).closest('.mktoFormRow').addClass('is-single');
        }

        $('input#' + id).after('<span class="checkmark" />');
      });

    // Radio, wrap each input+label and add markup
    self.form
      .getFormElem()
      .find('input[type=radio]')
      .each(function (i, el) {
        var id = $(el).attr('id');

        $('input#' + id + ', label[for=' + id + ']')
          .wrapAll('<div />')
          .closest('.mktoFormRow')
          .addClass('is-radio');

        $('input#' + id).after('<span class="checkmark" />');
      });
  }
  // more Marketo methods here
}

export default function initMarketo() {
  $(function () {
    if (typeof MktoForms2 !== 'undefined') {
      $('form[data-marketo-form]').each(function () {
        new Marketo($(this));
      });
    }
  });
}
